import * as Sentry from '@sentry/react';

import { CognitoSignInError } from '@/auth/utils/cognitoSignIn';
import ERROR_CODES from '@/core/apiErrorCodes';

/** A refusal whose message is written for the user. */
export class MfaSettingsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MfaSettingsError';
  }
}

/** Runs `op` while no other two-factor change is in flight. */
export type RunExclusive = <T>(op: () => Promise<T>) => Promise<T>;

/** A message for a failed MFA settings call; unexpected failures go to Sentry. */
export function mfaErrorMessage(err: unknown): string {
  if (err instanceof MfaSettingsError) return err.message;
  if (err instanceof CognitoSignInError) {
    switch (err.code) {
      case ERROR_CODES.AUTH_OTP_INVALID:
        return 'Invalid verification code';
      case ERROR_CODES.AUTH_INVALID_CREDENTIALS:
        return 'Password is incorrect';
      case ERROR_CODES.AUTH_TOO_MANY_ATTEMPTS:
        return 'Too many attempts. Please wait a few minutes and try again.';
    }
    return err.message;
  }
  Sentry.captureException(err);
  return 'Sorry, an error occurred. Please try again.';
}
